module.exports = __webpack_public_path__ + "media/images/logo_text_pl-c7ad89ce07742bd3edc86d8bafa1b988.svg";